var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notFound"}},[_vm._m(0),_c('p',{staticClass:"tips"},[_c('router-link',{attrs:{"to":"/","tag":"span"}},[_vm._v("<- 返回首页")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page404"},[_c('img',{attrs:{"src":require("../../assets/img/404.png"),"draggable":"false"}})])
}]

export { render, staticRenderFns }